/**
 * @generated SignedSource<<76101033b6cb12349c6d5dec3d28f94a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateDeliverableInput = {
  name?: string | null;
  description?: string | null;
  projectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateDeliverableMutation$variables = {
  input: CreateDeliverableInput;
};
export type CreateDeliverableMutation$data = {
  readonly createDeliverable: {
    readonly deliverable: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly description: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateDeliverableMutation = {
  variables: CreateDeliverableMutation$variables;
  response: CreateDeliverableMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDeliverablePayload",
    "kind": "LinkedField",
    "name": "createDeliverable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DeliverableTypeEdge",
        "kind": "LinkedField",
        "name": "deliverable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliverableType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDeliverableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateDeliverableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ba45d0819b4d3cda807f8cb16340314e",
    "id": null,
    "metadata": {},
    "name": "CreateDeliverableMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDeliverableMutation(\n  $input: CreateDeliverableInput!\n) {\n  createDeliverable(input: $input) {\n    deliverable {\n      node {\n        id\n        name\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4f62cf463f8fbb8db0d2123a1a043dd";

export default node;
